import React from 'react';
import { TextArea as TextAreaBase } from '@gravity-ui/uikit';
export const TextArea = ({ name, input, spec, inputProps }) => {
    const { value, onBlur, onChange, onFocus } = input;
    return (React.createElement(TextAreaBase, Object.assign({ maxRows: 20, minRows: 8, hasClear: true }, inputProps, { value: value || '', onBlur: onBlur, onFocus: onFocus, onUpdate: onChange, disabled: spec.viewSpec.disabled, placeholder: spec.viewSpec.placeholder, qa: name })));
};
